import React from 'react';
import styled, { keyframes } from 'styled-components/macro';

export const blink = keyframes`
  0% { opacity: 0 }
  5% { opacity: 1 }
  10% { opacity: 0.2 }
  15% { opacity: 0.2 }
  20% { opacity: 1 }
  25% { opacity: 0.2 }
  30% { opacity: 0.2 }
  35% { opacity: 1 }
  40% { opacity: 0.2 }
  55% { opacity: 0.2 }
  70% { opacity: 1 }
  75% { opacity: 0.2 }
  80% { opacity: 0.2 }
  85% { opacity: 1 }
  90% { opacity: 1 }
`;

const QdayAnimationStyles = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vw;
  max-height: 80vh;
  overflow: hidden;
  animation: ${blink} 1s forwards;
  .wrapper {
    width: 100%;
    height: 100%;
  }
  @media (min-aspect-ratio: 10 / 15) {
    height: 40vw;
  }
  @media (min-aspect-ratio: 1 / 1) {
    height: 80vw;
  }
  &::before, &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    height: 50%;
    z-index: 1;
  }
  &::before {
    background: linear-gradient(to bottom, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
    top: 0;
  }
  &::after {
    background: linear-gradient(to bottom, rgba(24, 24, 24, 0), rgba(24, 24, 24, 1));
    bottom: 0;
  }
`
const move = keyframes`
  from {
    transform: translate3d(0, 0, 0);
    opacity: 0.7;
  }

  to {
    transform: translate3d(0, -100%, 0);
    opacity: 1;
  }
`;
const move2 = keyframes`
  from {
    transform: translate3d(0, 0, 0);
    opacity: 0.5;
  }

  to {
    transform: translate3d(0, -100%, 0);
    opacity: 0.7;
  }
`;
const move3 = keyframes`
  from {
    transform: translate3d(0, 0, 0);
    opacity: 0.25;
  }

  to {
    transform: translate3d(0, -100%, 0);
    opacity: 0.5;
  }
`;
const move4 = keyframes`
  from {
    transform: translate3d(0, 0, 0);
    opacity: 0;
  }

  to {
    transform: translateY(-99.8%);
    opacity: 0.25;
  }
`;

const BarOne = styled.div`
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 33.33%;
  background: linear-gradient(to bottom, rgba(255,255,255,1), rgba(215,215,215,1));
  animation: ${move} 3s linear infinite;
`
const BarTwo = styled.div`
  position: absolute;
  top: 33.33%; left: 0; right: 0;
  height: 33.33%;
  background: linear-gradient(to bottom, rgba(255,255,255,1), rgba(215,215,215,1));
  animation: ${move2} 3s linear infinite;
`
const BarThree = styled.div`
  position: absolute;
  top: 66.66%; left: 0; right: 0;
  height: 33.33%;
  background: linear-gradient(to bottom, rgba(255,255,255,1), rgba(215,215,215,1));
  animation: ${move3} 3s linear infinite;
`
const LastBar = styled.div`
  position: absolute;
  top: 100%;
  left: 0; right: 0;
  height: 33.33%;
  background: linear-gradient(to bottom, rgba(255,255,255,1), rgba(215,215,215,1));
  animation: ${move4} 3s linear infinite;
`
const QdayAnimation = () => {
  return (
    <QdayAnimationStyles>
      <div className="wrapper">

        <BarOne />
        <BarTwo />
        <BarThree />
        <LastBar />

      </div>
    </QdayAnimationStyles>
  )
}

export default QdayAnimation;
